import { CARD_HEIGHT, CARD_WIDTH, Game } from '@phaser/scenes/Game';
import { EnemyObject } from '@phaser/objects/Enemy.object';

export class FocusBehavior {
  private _scene = Game.current;

  private _crosshair?: Phaser.GameObjects.Image;

  constructor(private _enemy: EnemyObject) {
    this.updateFocus(_enemy.targetIds);
  }

  public updateFocus(targetIds: string[]) {
    const isTargeting = targetIds.some(id => this._scene.id.startsWith(id));
    const color = isTargeting ? 0xFF0000 : 0x888888;

    if (this._crosshair) return this._crosshair?.setTint(color);

    this._crosshair = this._scene.add.image(-CARD_WIDTH/2+10, CARD_HEIGHT/2-20, 'sprites', 'crosshair')
      .setTint(color)
      .setScale(0.15);
    this._enemy.container.add(this._crosshair);
  }
}